import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  License User Approval Services
 * !== 면허 사용자 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/lcneusraprv`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/lcne-usr`,
    nodes: [],
};

export const URLS = {
    ptli0907001q: `${BASE.path}/ptli0907001q`, // License User List !==  면허 사용자 목록 ==!
    ptli0907002q: `${BASE.path}/ptli0907002q`, // License User Registration !==  면허 사용자 등록 ==!
};

export const APIS = {
    // Check License Usr List !==  면허 사용자 목록 조회 ==!
    getLcneUsrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/aply?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // License User details inquiry !== 면허 사용자 상세 정보 조회 ==!
    getLcneUsrInfo: (lcneCoAplyId: any) => {
        return api.get(`${BASE.api}/aply/${lcneCoAplyId}`);
    },
    // License User details inquiry !== 면허 사용자 상세 정보 조회 ==!
    executeLcneUsrAprv: (data: any) => {
        return api.post(`${BASE.api}/aprv`, {
            ...data,
        });
    },
    executeLcneUsrRtrn: (data: any) => {
        return api.post(`${BASE.api}/rtrn`, {
            ...data,
        });
    },
};

export const SF_LCNE_USR_SRCH: TFormSchema = {
    id: "form_lcneUsrSrch",
    schema: {
        lcneTpCd: {
            type: "select",
            label: "L_LCNE_TP",
            all: true,
            area: "comnCd",
            comnCd: "LCM0001",
            excludes: ["14"],
        },
        coTin: { type: "text", label: "L_CO_TIN" },
        coNm: { type: "text", label: "L_CO_NM" },
        bsopPrcssStat: {
            type: "select",
            label: "L_BSOP_PRCSS_STAT",
            options: [
                { label: "Unprocessed", value: "U" },
                { label: "Approved", value: "A" },
                { label: "Returned", value: "R" },
            ],
            all: true,
        },
    },
};

export const SG_LCNE_USR_LIST: TGridSchema = {
    id: "grid_lcneUsrList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_LCNE_TP", binding: "lcneTpCdNm", width: 0 }], show: false },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "15%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_LCNE_CO_APLC_NM", binding: "lcneCoAplcNm", width: "*" }] },
        { cells: [{ header: "L_BSOP_PRCSS_STAT", binding: "bsopPrcssStat", width: "15%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
        { cells: [{ header: "L_DELY_YN", binding: "delyYn", width: "5%" }] },
    ],
    body: [
        {
            cells: [{ binding: "lcneTpCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        {
            cells: [{ binding: "lcneCoAplcNm", align: "left" }],
        },
        {
            cells: [{ binding: "bsopPrcssStat" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
        {
            cells: [{ binding: "delyYn" }],
        },
    ],
};

export const SF_LCNE_USR_INFO: TFormSchema = {
    id: "form_lcneUsrInfo",
    schema: {
        lcneCoAplyId: { type: "text", label: "L_LCNE_CO_APLY_ID" },
        coTin: { type: "text", label: "L_CO_TIN", required: true },
        coNm: { type: "text", label: "L_CO_NM", required: true },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
            required: true,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10 },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5 },
        coPwd: { type: "password", label: "L_CO_PWD", required: true },
        coPwdCfrm: { type: "password", label: "L_CO_PWD_CFRM", required: true },
        emlAddrValdnYn: {
            type: "select",
            label: "L_EML_ADDR_VALDN_YN",
            required: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        preLcneCoAplyId: { type: "text", label: "L_PRE_LCNE_CO_APLY_ID" },
        aprvId: { type: "text", label: "L_APRV_ID" },
        lcneTpCd: {
            type: "checkbox",
            label: "L_LCNE_TP_CD",
            area: "comnCd",
            all: true,
            comnCd: "LCM0001",
            controlSize: 10,
            rows: 5,
            required: true,
            excludes: ["14"],
        },
        lcneTpCdNm: { type: "text", label: "L_LCNE_TP_CD_NM" },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5, required: true },
        bsopPrcssStat: { type: "text", label: "L_BSOP_PRCSS_STAT" },
        lcneCoAplcNm: { type: "text", label: "L_LCNE_CO_APLC_NM", required: true },
        ectYn: {
            type: "radio",
            label: "L_ECT_YN",
            options: [
                { label: "No", value: "N" },
                { label: "Yes", value: "Y" },
            ],
            defaultValue: "N",
        },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                // dclrYn: "Y",
            },
        },
        lcneUseTpCdArray: { 
            type: "array"
            , schema: {  
                lcneUseTpCd: { type: "text", label: "L_LCNE_TP_CD", edit: false }
                , lcneTpCd: { type: "text", label: "L_LCNE_TP_CD", edit: false }
                , type: {type: "select", options: [
                       {label: "기본", value: "BASE" }
                     , {label: "요청", value: "APPLY" }]
                }
            }
        },
    },
};
